const variables = {
  cta: {
    icon: 'ChevronRight',
    variant: 'primary',
  },
  settings: {
    cardTheme: 'light' as Theme,
  },
};

export default variables;
